import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination } from "swiper";
import RichText from "@ui/rich-text";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "./style.css";

SwiperCore.use([Pagination]);

const Carousel = ({ data, slides }) => {
    const pagination = {
        clickable: true,
        renderBullet: function (index, className) {
            return '<span class="' + className + '"></span>';
        },
    };

    const totalSlides = (slides ?? []).length;

    if (totalSlides == 0) return null;

    const maxWidthCss = totalSlides <= 2 ? "md:max-w-md" : "";

    return (
        <div className={maxWidthCss}>
            <div className="mb-6">
                <h3 className="text-lg text-skin-primary">{data.heading}</h3>
                <RichText
                    items={data.texts}
                    className="text-skin-primary mt-0 text-sm"
                />
            </div>
            <Swiper
                spaceBetween={0}
                slidesPerView={1.08}
                longSwipes={false}
                shortSwipes={true}
                autoHeight={true}
                pagination={pagination}
                className="pb-12"
                breakpoints={{
                    320: {
                        slidesPerView:
                            data.slidesPerView ?? data.slides?.length ?? 1,
                        spaceBetween: 0,
                    },
                    480: {
                        slidesPerView:
                            data.slidesPerViewDesktop ?? slides?.length ?? 1,
                        spaceBetween: 0,
                    },
                }}
            >
                {slides.map((slide, index) => {
                    return (
                        <SwiperSlide key={index}>
                            <div className="bg-white rounded-xl ml-4 p-5 shadow-md h-full">
                                {slide}
                            </div>
                        </SwiperSlide>
                    );
                })}
            </Swiper>
        </div>
    );
};

export default Carousel;
